module.exports = __webpack_public_path__ + "img/Growth.5cff882d.svg";